module.exports = __webpack_public_path__ + "static/media/0222_IMG_LE_SOL_MEGALITH_MEGABLACK.a3c805cb.webp";